// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Private Endpoint Service API
 * private-endpoint-service-api manages Private Endpoint Services in ingress clusters
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-networking@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  ErrorResponse,
  GetInternalProjectScopedOverview200Response,
} from '../models/index';
import {
  ErrorResponseFromJSON,
  ErrorResponseToJSON,
  GetInternalProjectScopedOverview200ResponseFromJSON,
  GetInternalProjectScopedOverview200ResponseToJSON,
} from '../models/index';

export interface GetInternalProjectScopedOverviewRequest {
  organizationId: string;
  projectId: string;
  regionId: string;
}

/**
 *
 */
export class InternalApi extends runtime.BaseAPI {
  /**
   * Returns the full PES infrastructure state joined across the customer CR, the regional ingress (PrivateEndpointService CR), and the per-orchestra data pipe (PrivateEndpoint CRs). Intended for internal support tooling. Requires a Neo4j employee Okta token.
   * Get a pre-joined overview of the PES connection chain for a given organization, project, and region.
   */
  async getInternalProjectScopedOverviewRaw(
    requestParameters: GetInternalProjectScopedOverviewRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<GetInternalProjectScopedOverview200Response>> {
    if (requestParameters['organizationId'] == null) {
      throw new runtime.RequiredError(
        'organizationId',
        'Required parameter "organizationId" was null or undefined when calling getInternalProjectScopedOverview().',
      );
    }

    if (requestParameters['projectId'] == null) {
      throw new runtime.RequiredError(
        'projectId',
        'Required parameter "projectId" was null or undefined when calling getInternalProjectScopedOverview().',
      );
    }

    if (requestParameters['regionId'] == null) {
      throw new runtime.RequiredError(
        'regionId',
        'Required parameter "regionId" was null or undefined when calling getInternalProjectScopedOverview().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('BearerAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }

    let urlPath = `/v1/internal/organizations/{organization_id}/projects/{project_id}/private-endpoint-service/regions/{region_id}/overview`;
    urlPath = urlPath.replace(
      `{${'organization_id'}}`,
      encodeURIComponent(String(requestParameters['organizationId'])),
    );
    urlPath = urlPath.replace(
      `{${'project_id'}}`,
      encodeURIComponent(String(requestParameters['projectId'])),
    );
    urlPath = urlPath.replace(
      `{${'region_id'}}`,
      encodeURIComponent(String(requestParameters['regionId'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      GetInternalProjectScopedOverview200ResponseFromJSON(jsonValue),
    );
  }

  /**
   * Returns the full PES infrastructure state joined across the customer CR, the regional ingress (PrivateEndpointService CR), and the per-orchestra data pipe (PrivateEndpoint CRs). Intended for internal support tooling. Requires a Neo4j employee Okta token.
   * Get a pre-joined overview of the PES connection chain for a given organization, project, and region.
   */
  async getInternalProjectScopedOverview(
    requestParameters: GetInternalProjectScopedOverviewRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<GetInternalProjectScopedOverview200Response> {
    const response = await this.getInternalProjectScopedOverviewRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
